module.exports = __webpack_public_path__ + "static/media/blog-brexit-and-uk-agrifood-square@2x.082da42f.jpg";